import {
  ManageOwnershipDialog,
  entityToOwnershipEntity,
  getDisabledSubscriptionOwnershipTooltip,
  getSubscriptionTechnicalContactRefs,
  getSubscriptionTechnicalContactsForDisplay,
  useManageOwnershipDialog,
} from '@internal/backstage-plugin-common-library-react';
import React from 'react';
import { useAsync } from 'react-use';

import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';

import {
  Box,
  Button,
  IconButton,
  Tooltip,
  makeStyles,
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const SUBSCRIPTION_OWNERSHIP_DOCS_URL =
  '/docs/default/component/frontstage/ownership/subscription/';

const useStyles = makeStyles(() => ({
  button: {
    textTransform: 'none',
  },
}));

export const SubscriptionManageOwnership = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const identityApi = useApi(identityApiRef);
  const { dialogOpen, openDialog, closeDialog, handleSuccess } =
    useManageOwnershipDialog({ dialogTarget: 'subscription' });

  const { value: userEntityRef } = useAsync(async () => {
    const identity = await identityApi.getBackstageIdentity();
    return identity.userEntityRef.toLocaleLowerCase();
  }, [identityApi]);

  const technicalContactRefs = getSubscriptionTechnicalContactRefs(entity);
  const isTechnicalContact = Boolean(
    userEntityRef && technicalContactRefs.includes(userEntityRef),
  );
  const buttonDisabled = !isTechnicalContact;

  const technicalContactsDisplay = getSubscriptionTechnicalContactsForDisplay(
    entity,
    technicalContactRefs,
  );

  let tooltipTitle: React.ReactNode = '';
  if (buttonDisabled) {
    tooltipTitle = getDisabledSubscriptionOwnershipTooltip({
      technicalContactsDisplay,
      includeContactSetupMessage: true,
    });
  }

  return (
    <>
      <Box display="flex" alignItems="center" gridGap={8}>
        <Tooltip title={tooltipTitle ?? ''}>
          <span>
            <Button
              className={classes.button}
              color="primary"
              variant="outlined"
              onClick={openDialog}
              disabled={buttonDisabled}
            >
              Manage Ownership
            </Button>
          </span>
        </Tooltip>
        <Tooltip title="Open subscription ownership documentation">
          <IconButton
            component="a"
            href={SUBSCRIPTION_OWNERSHIP_DOCS_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open subscription ownership documentation"
            size="small"
          >
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <ManageOwnershipDialog
        open={dialogOpen}
        entities={[entityToOwnershipEntity(entity)]}
        onClose={closeDialog}
        onSuccess={handleSuccess}
      />
    </>
  );
};
